import type { FC } from 'react'

import Select from 'react-select'

import { Translation } from '@/components/i18n/Translation'

const ReactSelect: FC<any> = ({
  options,
  value,
  placeholder = <Translation id="Select..." />,
  onChange,
  ...restOfProps
}) => (
  <Select
    className="react-select"
    options={options}
    // @ts-ignore
    value={options.find(option => option.value === value)}
    placeholder={placeholder}
    // @ts-ignore
    onChange={selectedOption => onChange(selectedOption.value)}
    {...restOfProps}
  />
)

export default ReactSelect
